import 'script-loader!jquery';
import 'script-loader!bootstrap/dist/js/bootstrap.bundle.min.js';
import 'script-loader!slick-carousel';
import 'script-loader!smartmenus';
import 'hamburgers/dist/hamburgers.css';
import AOS from 'aos';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import '@fortawesome/fontawesome-free/js/all.js';
import '@fortawesome/fontawesome-free/css/all.css';
import 'smartmenus/dist/css/sm-core-css.css';
import 'smartmenus/dist/css/sm-simple/sm-simple.scss';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import '../scss/entry.scss';

jQuery(document).ready(function($) {
	
	// tab content block
	$('.ffw-tabber').on('click', function() {
		$(this).siblings().removeClass('active');
	});
	
	// desktop header search toggle
	$('li.dt-search a').on('click', function() {
		$(this).children().toggleClass('fa-search fa-times');
		$('.dt-search-wrap').toggleClass('open closed');
		$('.utility-menu > .menu-item').each(function(i) {
			$(this).toggleClass('menu-item-hidden');
		})
	});

	// bootstrap popovers -- see: https://getbootstrap.com/docs/5.0/components/popovers/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="popover"]')[0]) {
			var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
			var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
				return new bootstrap.Popover(popoverTriggerEl)
			});
			// dismiss the popover on click
			var popover = new bootstrap.Popover(document.querySelector('.popover-dismiss'), {
				trigger: 'focus'
			});
		}
	});

	// bootstrap tooltips -- see: https://getbootstrap.com/docs/5.0/components/tooltips/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="tooltip"]')[0]) {
			var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
			var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
				return new bootstrap.Tooltip(tooltipTriggerEl)
			});
		}
	});

	// hamburger stuffs
	var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};
	var hamburgers = document.querySelectorAll(".hamburger");
	if (hamburgers.length > 0) {
		forEach(hamburgers, function(hamburger) {
			hamburger.addEventListener("click", function() {
				this.classList.toggle("is-active");
			}, false);
		});
	}

	// accordions
	$('.text-accordion-toggle').on('click', function(e) {
		var expanded = $(this).attr('aria-expanded') === 'true';
		$(this).toggleClass('accordion-active').attr('aria-expanded', !expanded);
		var panel = $(this).siblings('.text-accordion-content');
		if (!expanded) { panel.removeAttr('hidden').slideDown(500); }
		else { panel.slideUp(500, function() { $(this).attr('hidden', ''); }); }
	})

	// simple accordions
	$('.simple-accordion-toggle').on('click', function(e) {
		$(this).toggleClass('accordion-active');
		$(this).siblings('.simple-accordion-content').slideToggle(500);
	})

	// header search toggle
	$('#search-toggle').on('click', function() {
		$(this).toggleClass('glass').toggleClass('close');
		$('#search-box').toggleClass('open');
		$('#top-search').focus();
	});

	// add responsive class to all images
	$(function() {
		$('img').addClass('img-fluid');
	});

	// primary menu
	$(function() {
		$('.sm').smartmenus({
			subMenusSubOffsetX: 0,
			subMenusSubOffsetY: -1
		});
	});

	// primary navigation toggle
	$('.nav-toggle').on('click', function() {
		$('.primary-nav-wrap').slideToggle('fast');
	});

	// Calendar Toggle
	$('.concerts__concert--calendar-toggle').on('click', function(e) {
		$(this).toggleClass('calendar-active');
		$(this).siblings('.concerts__concert--calendar-options').slideToggle(300);
	})

	// scroll back to top button
	$(document).ready(function($){
		// browser window scroll (in pixels) after which the "back to top" link is shown
		var offset = 300,
			//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
			offset_opacity = 1200,
			//duration of the top scrolling animation (in ms)
			scroll_top_duration = 300,
			//grab the "back to top" link
			$back_to_top = $('.cd-top');
		//hide or show the "back to top" link
		$(window).scroll(function(){
			( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
			if( $(this).scrollTop() > offset_opacity ) { 
				$back_to_top.addClass('cd-fade-out');
			}
		});
		//smooth scroll to top
		$back_to_top.on('click', function(event){
			event.preventDefault();
			$('body,html').animate({
				scrollTop: 0 ,
				}, scroll_top_duration
			);
		});
	});

	// acf slider
	$('.slider-prev').on('click', function(){
		$(this).parent().prev().slick('slickPrev');
	});
	$('.slider-next').on('click', function(){
		$(this).parent().prev().slick('slickNext');
	});

	// header scroll effects
	(function () {
		var previousScroll = 0;
		$(window).scroll(function(){
			var scrollTop = $(window).scrollTop();
			var currentScroll = $(this).scrollTop();
			if (currentScroll > previousScroll) {
				$('#masthead').addClass('scrolling-down');
				$('#masthead').removeClass('scrolling-up');
			} else {
				$('#masthead').addClass('scrolling-up');
				
				$('#masthead').removeClass('scrolling-down');
			}
			if (scrollTop == 0) {
				$('#masthead').removeClass('scrolling-up');
			}
			previousScroll = currentScroll;
		});
	}());

	// fancybox
	Fancybox.bind("[data-fancybox]", {
		// Your custom options
	});

	// animate on scroll init
	const throttle = (func, delay) => {
		let prev = 0;
		return (...args) => {
			let now = new Date().getTime();

			if (now - prev > delay) {
				console.log('hit')
				prev = now;
				return func(...args);
			}
		}
	}
	AOS.init({ once: true, duration: 700 });
	$(window).on("scroll", throttle( function() { AOS.refresh() }, 500));
});